import _get from 'lodash/get';
import _unset from 'lodash/unset';
import { pruneSalesPersons } from '@/lib/serializerUtils';
import { calcItemPrice, isPresent, ruid } from '@/lib/utils';
import store from '@/store';

const orderlineHandler = (orderlines) => {
  return orderlines.map((line) => {
    const isPurchaseOrdered = _get(line, 'ispurchaseordered');
    if (isPurchaseOrdered === undefined) line = { ...line, ispurchaseordered: false };
    if (line.product.sitestocklevels !== undefined) _unset(line.product, 'sitestocklevels');
    return { ...line, itemprice: parseFloat(calcItemPrice(line)) };
  });
};

const orderDetailHandler = (orderDetails) => {
  return orderDetails.map((detail) => {
    const isPurchaseOrdered = _get(detail, 'ispurchaseordered');
    if (isPurchaseOrdered === undefined) detail = { ...detail, ispurchaseordered: false };
    return { ...detail, itemprice: parseFloat(calcItemPrice(detail)) };
  });
};

export default (record) => {
  // Calculate 'itemprice' for each order line and each order line's order details
  // Adds 'ispurchasedordered' to any orderline and orderdetail missing it.
  for (let i = 0; i < record.orders.length; i += 1) {
    if (!isPresent(record.orders[i].orderuid)) {
      // REFACTOR: This isn't ideal. We'd rather have all changes made PRIOR to serialization
      // and would like to get there someday in an object-oriented fashion: "Whenever about
      // to serialize an Order, do/add/change this and this..."
      const newOrderUID = ruid();
      record.orders[i].orderuid = newOrderUID;
      store.dispatch('editObject/updateValue', {
        key: 'orderuid',
        value: newOrderUID,
        path: `record.orders[${i}]`,
      });
    }
    if (record.orders[i].salecontractid === undefined) record.orders[i].salecontractid = null;
    const orderlines = _get(record, `orders[${i}].orderlines`, null);
    if (!orderlines) continue;
    record.orders[i].orderlines = orderlineHandler(orderlines);
    for (let j = 0; j < orderlines.length; j += 1) {
      const orderDetails = _get(record, `orders[${i}].orderlines[${j}].orderdetails`, null);
      if (!orderDetails) continue;
      record.orders[i].orderlines[j].orderdetails = orderDetailHandler(orderDetails);
    }

    const hasAdjustments = _get(record, `orders[${i}].adjustments`);
    if (hasAdjustments && hasAdjustments.length) {
      for (let a = 0; a < record.orders[i].adjustments.length; a += 1) {
        const adjOrderlines = _get(record, `orders[${i}].adjustments[${a}].orderlines`, null);
        if (!adjOrderlines) continue;
        record.orders[i].adjustments[a].orderlines = orderlineHandler(adjOrderlines, record.orders[i].adjustments[a], true);

        for (let b = 0; b < adjOrderlines.length; b += 1) {
          const adjOrderDetails = _get(record, `orders[${i}].adjustments[${a}].orderlines[${b}].orderdetails`, null);
          if (!adjOrderDetails) continue;
          record.orders[i].adjustments[a].orderlines[b].orderdetails = orderDetailHandler(adjOrderDetails);
        }
      }
    }
  }
  return pruneSalesPersons(record);
};
